import React from "react";
import { Toast } from "antd-mobile";
import http from "../../util/api";

const resid1 = "617193728135"; //批次签到控制表
const resid2 = "617396548838"; //批次签到记录表

class ConfirmSignin extends React.Component {
  componentDidMount() {
    let id = this.props.match.params.id;
    // alert(id)
    this.getStatus(id);
  }
  //获取签到状态，判断是否能够签到
  getStatus = async id => {
    try {
      let res = await http().getTable({
        resid: resid1,
        cmswhere: `testBatchId = ${id}`
      });
      let data = res.data;
      if (data.error === 0) {
				if(data.data.length){
					if (data.data[0].Checkstatus === "签到中") {
						await this.addRecord(id);
					} else {
						Toast.fail("签到已停止");
					}
				}else{
					Toast.fail('无效的二维码')
				}
      } else {
        Toast.fail(data.message);
        // alert(res.data.message)
      }
    } catch (error) {
      console.log(error);
      // alert("catch" + error.data.Message);
      Toast.fail(error.data.message);
    }
	};
	
  addRecord = async id => {
    try {
      let res = await http().addRecords({
        resid: resid2,
				data: [{ testBatchId: id }],
				isEditOrAdd: true
      });
      let data = res.data;
      if (data.Error === 0 || data.error === 0) {
        if (data.data.length) {
					console.log(data.data[0].batchId)
					sessionStorage.setItem('batchId', data.data[0].batchId)
          this.props.history.push("/start_test", {
            batchId: data.data[0].batchId
          });
        } else {
          Toast.fail("无数据");
        }
      } else {
        Toast.fail(data.message);
      }
    } catch (error) {
			console.log(error);
      // alert("catch" + error.data.Message);
      Toast.fail(error.data.message);
		}
	};
	
  render() {
    return null;
  }
}

export default ConfirmSignin;
